import React from "react";
import moment from "moment";
import Loader from "../../../components/Loader";
import NoData from "../../../components/NoData";

const BalanceProfitLoss = (props) => {
  const { rows, loading, page, pagination, limit, setLimit, setPage } = props;

  return (
    <div>
      {loading ? (
        <Loader message="Loading balance profit/loss..." />
      ) : !Array.isArray(rows) || rows.length === 0 ? (
        <NoData
          message="No Balance Profit/Loss Found"
          subText="Try changing date range or select another user."
        />
      ) : (
        <>
          <div className="tx-table-bpl-scroll">
            <div className="tx-table-header-bpl">             
              <div>Date</div>              
              <div>Purchase</div>
              <div>Cancel</div>
              <div>Win</div>
              <div>Calculation</div>
              <div>Profit/Loss</div>
              <div>Final</div>
            </div>

            <div className="tx-table-bpl">
              {rows.map((r, index) => {
                const opening = Number(r.opening_balance);
                const purchase = Number(r.total_purchase_amount || 0);
                const cancel = Number(r.total_cancel_amount || 0);
                const win = Number(r.total_win_amount || 0);
                const finalAmt = Number(r.final_amount || 0);
                const profitLoss = Number(r.profit_loss);
                const plClass =
                  profitLoss > 0
                    ? "profit"
                    : profitLoss < 0
                      ? "loss"
                      : "even";
                const plText =
                  profitLoss > 0
                    ? `+${profitLoss.toFixed(2)}`
                    : profitLoss < 0
                      ? `${profitLoss.toFixed(2)}`
                      : "0.00";

                return (
                  <div className="tx-row-bpl" key={`${r.txn_date}-${index}`}>                   
                    <div style={{ fontWeight: 800 }}>
                      {r.txn_date
                        ? moment(r.txn_date).format("DD/MM/YYYY")
                        : "-"}
                    </div>                    
                    <div className="tx-bpl-debit">{purchase.toFixed(2)}</div>
                    <div className="tx-bpl-credit">{cancel.toFixed(2)}</div>
                    <div className="tx-bpl-credit">{win.toFixed(2)}</div>
                    <div className="tx-bpl-calc">{r.calculation || "-"}</div>
                    <div className={`tx-bpl-pl ${plClass}`}>{plText}</div>
                    <div style={{ fontWeight: 900 }}>{finalAmt.toFixed(2)}</div>
                  </div>
                );
              })}
            </div>
          </div>

          {pagination && pagination.totalPages > 1 && (
            <div className="modern-pagination">
              <div className="mp-limit">
                <span>Show</span>
                <select value={limit} onChange={(e) => setLimit(e.target.value)}>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>

              <div className="mp-controls">
                <button disabled={page === 1} onClick={() => setPage(page - 1)}>
                  Prev
                </button>

                <div className="mp-info">
                  Page <strong>{pagination.page}</strong> of{" "}
                  <strong>{pagination.totalPages}</strong>
                </div>

                <button
                  disabled={page === pagination.totalPages}
                  onClick={() => setPage(page + 1)}
                >
                  Next
                </button>
              </div>

              <div className="mp-jump">
                <select value={page} onChange={(e) => setPage(e.target.value)}>
                  {Array.from({ length: pagination.totalPages }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      Page {i + 1}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BalanceProfitLoss;